/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdvancedCreateAndEditWithAnchorNavigatorTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2V2zm2 2v16h16V4H4zm1 1h9v14H5V5zm2 2v10h5V7H7zm12 0h-4V5h4v2zm0 3h-4V8h4v2zm0 3h-4v-2h4v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAdvancedCreateAndEditWithAnchorNavigatorTemplate as AdvancedCreateAndEditWithAnchorNavigatorTemplate };
